import { useEffect } from 'react';
import { useSettingsStore } from '@/store/settingsStore';

/**
 * ThemeProvider Component
 * 
 * Applies the theme class to the document root element based on the settings store.
 * This enables Tailwind's dark mode functionality using the 'class' strategy.
 */

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useSettingsStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    
    // Remove existing theme classes
    root.classList.remove('light', 'dark');
    
    // Add current theme class
    root.classList.add(theme);
  }, [theme]);

  return <>{children}</>;
}